/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const StripeTransactionType = {
  CardStored: "CARD_STORED",
  CardKeyed: "CARD_KEYED",
  CardReader: "CARD_READER",
  Wallet: "WALLET",
} as const;

export type StripeTransactionType =
  (typeof StripeTransactionType)[keyof typeof StripeTransactionType];

export type StripeTransactionTypeEnumType = typeof StripeTransactionType;
export type StripeTransactionTypeOptional = StripeTransactionType;
export type StripeTransactionTypeTrackedI = StripeTransactionType;
export type StripeTransactionTypeTracked = StripeTransactionType;
export type StripeTransactionTypeMetaI = EnumMetaType<
  StripeTransactionTypeEnumType,
  StripeTransactionType
>;
export const StripeTransactionTypeMeta = typeMetaEnum<
  StripeTransactionTypeEnumType,
  StripeTransactionType
>("StripeTransactionType", StripeTransactionType);
export function transformDatesStripeTransactionType(
  model: StripeTransactionType,
) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
